import {
  listPropertiesForMap
} from "./chunk-MPUZIXB6.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  mapSearchListingsFiltersToSearchFilterRequest
} from "./chunk-KLW2VFR7.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/searchListingsCoordinates/searchListingsCoordinates.ts
async function searchListingsCoordinates(filters, options, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "searchListingsCoordinates");
  const appliedFilters = mapSearchListingsFiltersToSearchFilterRequest(filters, options);
  try {
    const data = await listPropertiesForMap(
      appliedFilters,
      options.marketCountryCode ? { marketCountryCode: options.marketCountryCode } : void 0,
      _apiConfig
    );
    return {
      status: "success",
      data,
      metadata: { appliedFilters }
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error, { appliedFilters });
  }
}

export {
  searchListingsCoordinates
};
